import React from "react";

const InputField = ({
  placeholder,
  name,
  type = "text",
  value,
  required = false,
  ...rest
}) => {
  return (
    <div>
      <input
        className="form__input"
        type={type}
        placeholder={placeholder}
        name={name}
        // onChange={formik.handleChange}
        // value={formik.values.email}
        value={value}
        required={required}
        // onChange={(e) => {
        //     onChange(name, e.target.value);
        // }}
        {...rest}
      />
      {rest?.touched && rest?.error && (
        <div className={`error ${rest.newClass}`}>{rest.error}</div>
      )}
    </div>
  );
};

export default InputField;
